<app-banner [heading]="'SCHOOL RESULTS - ACADEMIC ACHIEVERS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	<!-- ======= Recent Activities Section ======= -->
    <section id="events2" class="events2">
      <div class="container" data-aos="fade-up">

        <div class="row">
		
		<!-- ======= Grade I ======= -->
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(14).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Ritvij<br> Grade I </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
			</div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(15).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Samarth Gandhe<br> Grade I </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
			</div>
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(16).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Shanaya Chouhan<br> Grade I </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
			</div>
				
		<div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(17).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Advit<br> Grade I </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
			</div>
          <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(18).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Tani<br> Grade I </h5>
                <p class="font-italic text-center">Position - IIIrd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  </div>
		      <div class="row">
		  <!-- ======= Grade I ======= -->
		  <!-- ======= Grade II ======= -->
		   <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(27).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title"> Yogya<br> Grade II </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(28).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title"> Rupika<br> Grade II </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(29).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Rittam Kakkar<br> Grade II </h5>
                <p class="font-italic text-center">Position - IIIrd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(30).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Bhavika<br> Grade II </h5>
                <p class="font-italic text-center">Position - IIIrd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		   </div>
		   <div class="row">
		  <!-- ======= Grade II ======= -->
		  <!-- ======= Grade III ======= -->
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(4).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Atharv<br> Grade III </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(6).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Anirudh<br> Grade III </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(5).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Swastik<br> Grade III </h5>
                <p class="font-italic text-center">Position - IIIrd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <!-- ======= Grade III ======= -->
		  <!-- ======= Grade IV ======= -->
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(3).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Uddish<br> Grade IV </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(2).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Rudra Walia <br> Grade IV </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(1).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Parth<br> Grade IV </h5>
                <p class="font-italic text-center">Position - IIIrd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <!-- ======= Grade IV ======= -->
		  <!-- ======= Grade V ======= -->
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(10).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Nikunj<br> Grade V </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(11).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Medhanshi<br> Grade V </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(12).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Tejas<br> Grade V </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(13).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Sujal<br> Grade V </h5>
                <p class="font-italic text-center">Position - IIIrd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  		  </div>
		      <div class="row">
		  <!-- ======= Grade V ======= -->
		  <!-- ======= Grade VI ======= -->
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(21).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Nishtha Soni<br> Grade VI </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(20).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Khadija Ghazi<br> Grade VI </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(19).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Vanika<br> Grade VI </h5>
                <p class="font-italic text-center">Position - IIIrd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <!-- ======= Grade VI ======= -->
		  <!-- ======= Grade VII ======= -->
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/17.jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Shivam Talwar<br> Grade VII </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(7).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Tanveer<br> Grade VII </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		   <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(8).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Kunal<br> Grade VII </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(9).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Jayant<br> Grade VII </h5>
                <p class="font-italic text-center">Position - IIIrd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
				  </div>
		      <div class="row">
		  <!-- ======= Grade VII ======= -->
		  <!-- ======= Grade VIII ===== -->
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(22).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Arshpreet<br> Grade VIII </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(23).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Mannat<br> Grade VIII </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/().jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Harman<br> Grade VIII</h5>
                <p class="font-italic text-center">Position - IIIrd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <!-- ======= Grade VIII ===== -->
		  <!-- ======= Grade IX ======= -->
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(26).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Vaani Gill<br> Grade IX </h5>
                <p class="font-italic text-center">Position - Ist</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(24).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Anshul<br> Grade IX </h5>
                <p class="font-italic text-center">Position - IInd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		  <div class="col-md-4 d-flex align-items-stretch">
            <div class="card">
              <div class="card-img">
                <img src="assets/img/schoolresult/(25).jpg" alt="...">
              </div>
              <div class="card-body">
                <h5 class="card-title">Jasleen<br> Grade IX </h5>
                <p class="font-italic text-center">Position - IIIrd</p>
                <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
				</p> -->
              </div>
            </div>
          </div>
		   
			
			
		</div>

      </div>
    </section><!-- End Recent Activities Section -->
	
  </main>